/**
 * In place of the shell for an account that holds no permission: someone whose
 * first Microsoft sign-in created their account, before an admin gives it a
 * role. Nothing is fetched; the server would refuse it all anyway.
 */

import { LogOut, UserX } from 'lucide-react';

import { useSignOut } from '@/api/queries';
import { useSession } from '@/session/SessionContext';
import { ActionButton, buttonState } from '@/ui/ActionButton';
import { StateCard } from '@/ui/StateCard';

export function NoAccess() {
  const { user } = useSession();
  const signOut = useSignOut();
  return (
    <div className="boot-screen">
      <div className="boot-card">
        <StateCard icon={<UserX aria-hidden="true" />} title="You don't have access yet">
          <p>An administrator needs to give your account a role.</p>
          <p className="hint">{user?.email}</p>
          <p className="empty-actions">
            <ActionButton
              state={buttonState(signOut)}
              type="button"
              className="btn btn-secondary"
              icon={<LogOut aria-hidden="true" />}
              label="Sign out"
              pendingLabel="Signing out…"
              onClick={() => signOut.mutate()}
            />
          </p>
        </StateCard>
      </div>
    </div>
  );
}
